import React from 'react';

const CaseStudies = () => {
  return (
    <div className="page">
      <h1>Case Studies</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default CaseStudies; 